<!-- Observer.vue -->
<template>
  <div class="observer"></div>
</template>

<script>
export default {
  props: {
    options: { required: false, default: null },
    keepConnectedOnIntersection: { required: false, default: false },
    emitNotIntersecting: { required: false, default: false },
  },
  data: () => ({
    observer: null,
    notIntersecting: true,
  }),
  mounted() {
    const options = this.options || { rootMargin: "750px" };
    this.observer = new IntersectionObserver(([entry]) => {
      if (entry && entry.isIntersecting) {
        this.notIntersecting = false;
        this.$emit("intersect");
        if (!this.keepConnectedOnIntersection) {
          this.observer.disconnect();
        }
      } else if (this.emitNotIntersecting && !this.notIntersecting) {
        this.notIntersecting = true;
        this.$emit("notIntersecting");
      }
    }, options);
    this.observer.observe(this.$el);
  },
  destroyed() {
    this.observer.disconnect();
  },
};
</script>
